import { i18nConfig } from '@/i18n/config';

export function getPathLocale(pathname: string) {
  const { locales } = i18nConfig;
  return locales.find(
    (locale) => pathname?.startsWith(`/${locale}/`) || pathname === `/${locale}`
  );
}
